<template>
	<div>
		<!-- พื้นที่คงที่ของหน้าแรก -->
		<div class="index-wrap" :style="{ background: backgroundColor }" v-if="adList.length">
			<div class="index">
				<div class="banner">
					<el-carousel height="500px" arrow="hover" v-loading="loadingAd" @change="handleChange">
						<el-carousel-item v-for="item in adList" :key="item.adv_id">
							<el-image :src="$img(item.adv_image)" fit="cover" @click="$router.pushToTab(item.adv_url.url)" />
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
		</div>
<div class="row content-json-container container" style="     margin-top: 49px;     padding-bottom: 120px;
            ">
			
			
			
			
			
			
			
			
			
			
			
				<div class="content" >
			<div class="content-div" v-if="adLeftList.length > 0 || adRightList.length > 0">
						<div class="ad-wrap">
							<div class="ad-big" v-if="adLeftList.length > 0">
								<div class="ad-big-img" v-for="(item, index) in adLeftList" :key="index">
									<el-image :src="$img(item.adv_image)" fit="cover" style="    box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
			border-radius: 8px;" @error="adLeftImageError(index)" @click="$router.pushToTab(item.adv_url.url)"></el-image>
								</div>
							</div>
							<div class="ad-small" v-if="adRightList.length > 0">
								<div class="ad-small-img" v-for="(item, index) in adRightList" :key="index">
									<el-image :src="$img(item.adv_image)" fit="cover" style="    box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
			border-radius: 8px;" @error="adRightImageError(index)" @click="$router.pushToTab(item.adv_url.url)"></el-image>
								</div>
							</div>
						</div>
					</div>
			
			
			</div>
			
			
			
			
			
			
			
			
			
			
			
			
			
	<div class="moduleWarp" data-sort="1" id="module_635670" moduleid="635670" relatedid="1344" data-level="" module-type="4" style="display: block;     width: 100%;">
	        <div class="ContentShow ">
	                                      
	<div class="LeftClickLi  module-user-recommend" data-level="" moduleid="635670">
	    <ul class="module_banner over-in placeholderJs">
	        <li bannerid="1028662" class="li-nohover">
	            <a thisid="1028662" href="javascript:void(0);"  v-if="adcoup.length > 0 || adcoup.length > 0" > 
					<img class="lazy_img placeholder_img"   v-for="(item, index) in adcoup" :key="index"   v-if="index==0"   data-type="" 
					  :src="$img(item.adv_image)" @click="$router.pushToTab(item.adv_url.url)"
					 ></a>
	                                   
			
			   
			   
	                </li>
	        </ul>
	</div>
	
	
	
	            </div>
				
				
				<div class="moduleWarp" data-sort="" v-if="addonIsExit.coupon == 1 && couponList.length > 0"  id="module_632998" moduleid="632998" relatedid="1344" data-level="" module-type="43" style="display: block; width: 100%; padding-top: 20px;" >
				        <div class="ContentShow ">
				                                      <div class="adv_module_43 New_clear" data-level="" id="couponModule_632998" moduleid="632998" :style="{ 'background': 'url(' +  this.adcoup3[0].adv_image  + ')' }" style="
    background-repeat: round;
    background-size: cover;">
				    
				 
				   
				            <div class="coupon-module-warp">
				        <ul>
				            
				
				
				<li class="ky-coupon-item " id="ky-coupon-item-5204128" data-id="" v-for="(item, index) in couponList" :key="index" >
						<div class="ky-coupon-item-margin">
						<div class="ky-coupon-bg">
													<img src="https://s2.konvy.com/static/img/new_coupon/p_coupon_bg.png" class="ky-v-top" alt="coupon">
						</div>
						<div class="ky-coupon-cont">
							<div class="ky-coupon-l">
			<img :src="$img(siteInfo.logo)" class="ky-coupon-logo" alt="">
																<p class="ky-coupon-participant ky-limit-more">ผลิตภัณฑ์ทั้งหมด</p>
											</div>
							<div class="ky-coupon-r">
								<div class="ky-coupon-r-cont ky-pos  ">
									
									
									<div class="ky-coupon-rl-wrap" v-if="item.type == 'reward'" :class="{ disabled: item.useState == 2 }"  >
										<p class="ky-coupon-type ky-limit-one"  style="
				    padding-top: 13px;
				    font-weight: bold;
				    line-height: 36px;
				    display: flex;
				    align-items: baseline;
				">
																		<!-- Deduct -->
											<span class="ky-coupon-deduct "><span class="ky-money ky-lh-1">฿</span>{{parseInt(item.money) }}</span>
																	</p>
																	
																	
																	
																	
										<p class="ky-coupon-period-text ky-d-ib ky-text-regular ky-limit-more" >สั่งซื้อขั้นต่ำ {{ item.at_least }} บาท</p>
																<div class="ky-coupon-condition-wrap">
																		<span title="สำหรับลูกค้าใหม่">สำหรับทุกคน</span>
																	</div>
															</div>
															
															
															
															
															<div class="ky-coupon-rl-wrap" v-else-if="item.type == 'discount'" :class="{ disabled: item.useState == 2 }"  >
																					<p class="ky-coupon-type ky-limit-one"  style="
															    padding-top: 13px;
															    font-weight: bold;
															    line-height: 36px;
															    display: flex;
															    align-items: baseline;
															">
																												
																						<span class="ky-coupon-deduct ">{{ 100-(parseFloat(item.discount))*10 }}<span class="ky-money ky-lh-1">%</span></span>
																												</p>
																												
																												
																												
																												
																					<p class="ky-coupon-period-text ky-d-ib ky-text-regular ky-limit-more" >สั่งซื้อขั้นต่ำ {{ item.at_least }} บาท</p>
																											<div class="ky-coupon-condition-wrap">
																													<span title="สำหรับลูกค้าใหม่">สำหรับทุกคน</span>
																												</div>
																										</div>
																										
																										
																										
																										
															
															
															
														<div class="ky-coupon-rr-wrap">
																						<!-- 可领取 -->
										<a class="ky-coupon-button" v-if="item.useState == 0"  @click="couponTap(item, index)" coupon-id="5204128" bannerid="1026236" style="    color: #ffffff;">เก็บคูปอง</a>
										
										
										<a class="ky-coupon-button" v-if="item.useState != 0"  coupon-id="5204128" bannerid="1026236" style="    color: #ffffff;">เก็บคูปองแล้ว</a>
															</div>
													</div>
								<div class="ky-coupon-period">
									<span class="ky-limit-one ">อายุการใช้งาน {{ timeConverter(item.end_time) }} </span>
														<div class="ky-float-r ky-pos ky-coupon-more">
										<i class="ky-coupon-more-icon"></i>
										<div class="ky-coupon-more-fixed">
											<div class="ky-coupon-more-wrap">
												<ul>
													<li>
														<p>ระยะเวลา</p>
																								<span>อายุการใช้งาน {{ timeConverter(item.end_time) }}</span>
																							</li>
													<li>
														<p>เงื่อนไข</p>
														<span>1.สั่งซื้อขั้นต่ำ 399 บาท<br>2.คูปองสำหรับผู้ใช้ใหม่เท่านั้น<br>3.คูปองนี้ไม่สามารถใช้ร่วมกับคูปองอื่นได้</span>
													</li>
													<li>
														<p>ข้อจำกัด</p>
														<span>ผลิตภัณฑ์ทั้งหมด</span>
													</li>
													<li>
														<p>ข้อมูลเพิ่มเติม</p>
														<span>กดรับได้ 1 ครั้ง เท่านั้น</span>
													</li>
												</ul>
											</div>
										</div>
									</div>
													</div>
							</div>
						</div>
					</div>
				</li>
				        </ul>
				    </div>
				        <!-- End 优惠卷 -->
				</div>
				            </div>
				    </div>
				
	    </div>
	
	
	
	
</div>



























<div class="row content-json-container container" style=" display: none;
            ">
	<div class="main-section">
		<a id="coupon_list-13-a" class="content-json-target"></a>
		<div id="coupon_list-13" class="content-block coupon_list both">
			<div id="bindingBackground" style="width:100%;
                                    margin-bottom : 0px;
                                    
                
                            ">
				<div class="coupon-list-wrapper ">
					<div id="product-detail-coupon-list" class="coupon___cart__flex coupon-3889" v-for="(item, index) in couponList" :key="index">
						<div class="coupon___cart__top" v-if="item.type == 'reward'" :class="{ disabled: item.useState == 2 }">
							<div class="circle-coupon__top circle__left" style="background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0);"> </div>
							<div class="circle-coupon__top circle__right" style="background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0);"> </div>
							<div class="got-coupon-card__top">
								<div class="coupon-headers">ลดเพิ่ม</div>
								<div class="coupon-price"> {{parseInt(item.money) }}.- </div>
								<div class="coupon-description">เมื่อช้อปสินค้าครบ {{ item.at_least }}.- </div>
								<div class="coupon-description coupon-description-2">หมดอายุ{{ timeConverter(item.end_time) }} </div>
							</div>
						</div>
						
						
						
						<div class="coupon___cart__top" v-else-if="item.type == 'discount'" :class="{ disabled: item.useState == 2 }">
							<div class="circle-coupon__top circle__left" style="background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0);"> </div>
							<div class="circle-coupon__top circle__right" style="background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0);"> </div>
							<div class="got-coupon-card__top">
								<div class="coupon-headers">ลดเพิ่ม</div>
								<div class="coupon-price"> {{ parseFloat(item.discount) }}% </div>
								<div class="coupon-description" >เมื่อช้อปสินค้าครบ {{ item.at_least }}.- ขึ้นไป </div>
								<div class="coupon-description coupon-description-2">หมดอายุ {{ timeConverter(item.end_time) }} </div>
							</div>
						</div>
						
						
						
						
						
						
						
						
						
						
						
						<div class="coupon___cart__bottom" style="">
							<div class="got-coupon-card__bottom">
								<div class="got__coupon__bottom">
									<div class="coupon-text"> <a class="link get-coupon keep" data-coupon-id="3889" @click="couponTap(item, index)" >เก็บคูปอง</a> </div>
								</div>
							</div>
						</div>
						
						<div class="coupon-claimed d-flex-center" v-if="item.useState != 0" >
						                        <div class="circle-coupon__top circle__left"> </div>
						                        <div class="circle-coupon__top circle__right"> </div>
						                        <div class="text-claimed">
						                            เก็บแล้ว
						                        </div>
						                    </div>
						
						
						
						
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
		<div class="content"  style="padding-bottom: 10px;">
			<!-- ศูนย์รับบัตรกํานัล -->
			<div class="content-div" style=" display: none;" v-if="addonIsExit.coupon == 1 && couponList.length > 0">
				<div class="coupon">
					<div class="coupon-title">
						<p class="coupon-font" style="font-size: 29px;">คูปอง</p>
						<p class="coupon-en">coupon</p>
						<p class="coupon-more" @click="$router.push('/coupon')">
							<span>ดูเพิ่มเติม</span>
							<i class="iconfont iconarrow-right"></i>
						</p>
					</div>

					<ul class="coupon-list">
						<li v-for="(item, index) in couponList" :key="index">
							<p class="coupon-price ns-text-color" v-if="item.type == 'reward'" :class="{ disabled: item.useState == 2 }">
								฿
								<span>{{parseInt(item.money) }}</span>
							</p>
							<p class="coupon-price ns-text-color" v-else-if="item.type == 'discount'" :class="{ disabled: item.useState == 2 }">
								
								<span>{{ parseFloat(item.discount) }}</span>พับ
							</p>
							<p class="coupon-term" v-if="item.at_least > 0" :class="{ disabled: item.useState == 2 }">เต็ม{{ item.at_least }}มีอยู่</p>
							<p class="coupon-term" v-else :class="{ disabled: item.useState == 2 }">เต็ม{{ item.at_least }}มีอยู่</p>
							<p class="coupon-receive ns-text-color" @click="couponTap(item, index)">
								<span v-if="item.useState == 0">รับสิทธิ์ตอนนี้เลย</span>
								<span v-else>ไปและใช้</span>
								<i class="iconfont iconarrow-right"></i>
							</p>
						</li>
					</ul>
				</div>
			</div>

			<!-- โฆษณา -->
			<div class="moduleWarp index_flash_click new-module-20-warp adadadadxxx list-countNum-5  moduleCate" moduleid="227413" module-type="72" id="module_227413" data-level=""  :style="{ 'background': 'url(' +  this.adcoup77[1].adv_image  + ')' }" style="  
			    display: block;
			    background-size: cover;
			    background-repeat: no-repeat;
			    background-color: #ffd030;" v-if="this.listData.length">
			<div class="module-20-bg" ></div>
			<div class="ContentShow" style="display: block;     padding-top: 131px; ">
			    <div class="module-20-cont clear">
			        <div class="module-20-Head">
			            <img :src="this.adcoup77[0].adv_image" class="module-20-icon" alt="">
			            <div class="module-20-time">
			                <div id="flash_sale_new_227413" class="flash_deal_time3" moduleid="227413" data-related-type="index" data-related-id=""><count-down
											class="count-down"
											v-on:start_callback="countDownS_cb()"
											v-on:end_callback="countDownE_cb()"
											:currentTime="seckillTimeMachine.currentTime"
											:startTime="seckillTimeMachine.startTime"
											:endTime="seckillTimeMachine.endTime"
											:dayTxt="'：'"
											:hourTxt="'：'"
											:minutesTxt="'：'"
											:secondsTxt="''"
										></count-down></div>
			                                
			                            </div>
			            <div class="finishedImage"></div>
			                        <a  class="module-20-viewall" style="font-weight: 800; color: #fff;">ดูทั้งหมด</a>
			                    </div>
								<div class="module-20-team">
			                <vue-seamless-scroll :data="listData" :class-option="optionLeft" class="seamless-warp2" >
			                	<ul class="item" :style="{ width: 250 * listData.length + 'px' }" >
			                		<li v-for="(item, index) in listData" :key="index" style=" padding: 0 10px; border-right : 0px solid #f1f1f100; ">
			                			<div class="seckill-goods" @click="$router.pushToTab('/promotion/seckill-' + item.id)" style="border-radius: 14px;
			    background: #fff;
			    padding: 10px;
			    cursor: pointer;">
			                				<div class="seckill-goods-img"><img :src="$img(item.goods_image, { size: 'mid' })" @error="imageError(index)" /></div>
			                				<p style=" font-family: 'sukhumvittadmai'; padding-top: 10px; font-weight: 600;" >{{ item.goods_name }}</p>
			                				<div class="seckill-price-wrap">
			                					<p class="ns-text-color" style=" font-family: 'sukhumvittadmai2'; font-weight: 800;"  >
			                						฿
			                						<span style=" font-family: 'sukhumvittadmai2'; font-weight: 800;" >{{ item.seckill_price }}</span>
			                					</p>
			                					<p class="primary-price" style=" font-family: 'sukhumvittadmai'; font-weight: 600;" >฿{{ item.price }}</p>
			                				</div>
			                			</div>
			                		</li>
			                	</ul>
			                </vue-seamless-scroll>
			                </div>
							
			                <a href="javascript:;" class="k-team-prev-btn" id="swiper_left_227413"><span class="arrow arrow-left"></span></a>
			        <a href="javascript:;" class="k-team-next-btn" id="swiper_right_227413"><span class="arrow arrow-right"></span></a>
			            </div>
			        
			    </div>
			</div>
			
			
			
			
			
			<div class="moduleWarp isTitleWarp" data-sort="" id="module_210715" moduleid="210715" relatedid="" data-level="" module-type="3" style="display: block;  margin-top: 50px;  ">
			        <div class="ContentShow ">
			                                        <!-- 标题模板start -->
			<div class="RBigTitle placeholderJs" data-level="" moduleid="210715">
			    <ul class="module_banner">
			                <!--判断没有链接-->
			        <li>
			            <a thisid="170203"  v-if="adtip.length > 0 || adtip.length > 0"  data-type=""  target="_blank">
						<img class="lazy_img placeholder_img" v-for="(item, index) in adtip" :key="index"   v-if="index==0" data-h="115" 
						 :src="$img(item.adv_image)" @click="$router.pushToTab(item.adv_url.url)" ></a>
			                    </li>
			            </ul>
			</div>
			<!-- 标题模板end -->            </div>
			    </div>
			<!-- เวลาจํากัดพุ่งสูงขึ้น -->
			<div class="content-div"   v-if="adtip2.length > 0 || adtip2.length > 0"   style="     margin-top: 50px;   " ><div class="ad-wrap">
			<el-carousel :interval="4000" type="card" height="350px" style="    width: 100%; ">
			    <el-carousel-item v-for="(item, index) in adtip2" :key="index"   @click="$router.pushToTab(item.adv_url.url)"  style=" border-radius: 10px">
			    <img :src="$img(item.adv_image)" alt="Trulli" style="width: 100%; border-radius: 10px">
			    </el-carousel-item>
			  </el-carousel>
			</div>
			</div>
			
			
			
			
			<div class="moduleWarp in-Full-Screen module_banner"  v-if="adtaplong.length > 0 || adtaplong.length > 0"  id="module_219003" moduleid="219003" module-type="34" relatedid="" data-level="" style="display: block; padding-top: 74px;  " >
        <a v-for="(item, index) in adtaplong" :key="index"   @click="$router.pushToTab(item.adv_url.url)" thisid="190577" data-type=""><img :src="$img(item.adv_image)" ></a>
	        </div>



			<!-- พื้นที่ชั้น -->
			<div class="content-div" style="      
    padding-top: 29px;">
				<div class="floor" style="width: 1400px;  ">
					<div v-for="(item, index) in floorList" :key="index" class="floor_item">
						<floor-style-1 v-if="item.block_name == 'floor-style-1'" :data="item" />
						<floor-style-2 v-if="item.block_name == 'floor-style-2'" :data="item" />
						<floor-style-3 v-if="item.block_name == 'floor-style-3'" :data="item" />
						<floor-style-4 v-if="item.block_name == 'floor-style-4'" :data="item" />
					</div>
				</div>
			</div>
			
			<!-- พื้นที่ลอยน้ํา -->
			<div class="floatLayer-wrap" v-if="floatLayer.is_show_type">
				<div class="floatLayer">
					<div class="img-wrap">
						<img :src="$img(floatLayer.img_url)" @click="$router.pushToTab(floatLayer.link.url)" />
					</div>
					<i class="el-icon-circle-close" @click="closeFloat"></i>
				</div>
			</div>

			<!-- ค้นหาโฮเวอร์ -->
			<div class="fixed-box" style="display: none">
				<div class="header-search">
					<el-row>
						<el-col :span="6">
							<router-link to="/" class="logo-wrap"><img :src="$img(siteInfo.logo)" /></router-link>
						</el-col>
						<el-col :span="13">
							<div class="in-sousuo">
								<div class="sousuo-box">
									<el-dropdown @command="handleCommand" trigger="click">
										<span class="el-dropdown-link">
											{{ searchTypeText }}
											<i class="el-icon-arrow-down"></i>
										</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item command="goods">สินค้า</el-dropdown-item>
											<el-dropdown-item command="shop">ร้าน</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
									<input type="text" :placeholder="defaultSearchWords" v-model="keyword" @keyup.enter="search" maxlength="50" />
									<el-button type="primary" size="small" @click="search">ค้น</el-button>
								</div>
							</div>
						</el-col>
						<el-col :span="5">
							<div class="cart-wrap">
								<router-link class="cart" to="/cart">
									<span>ตะกร้าสินค้าของฉัน</span>
									<el-badge v-if="cartCount" :value="cartCount" type="primary"><i class="iconfont icongouwuche"></i></el-badge>
									<i v-else class="iconfont icongouwuche"></i>
								</router-link>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			
			
			
			
			
			
		
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
		</div>
	</div>
</template>

<script>
import floorStyle1 from './components/floor-style-1.vue';
import floorStyle2 from './components/floor-style-2.vue';
import floorStyle3 from './components/floor-style-3.vue';
import floorStyle4 from './components/floor-style-4.vue'; 
import index from './_index/index.js';
import store from "@/store";
export default {
	name: 'index',
	components: { floorStyle1,floorStyle2,floorStyle3,floorStyle4 },
	mixins: [index],
	store,
	metaInfo() {
		
		console.log(store.getters.siteInfo);
	    return {
			title: store.getters.siteInfo.site_name || "",
	        meta: [
	            { name: "description", content: store.getters.siteInfo.seo_description || "" },
	            { name: "keywords", content: store.getters.siteInfo.seo_keywords || ""}
	        ]
	    }
	},
	methods:{
		timeConverter(UNIX_timestamp){
		  var a = new Date(UNIX_timestamp * 1000);
		  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
		  var year = a.getFullYear();
		  var month = months[a.getMonth()];
		  var date = a.getDate();
		  var hour = a.getHours();
		  var min = a.getMinutes();
		  var sec = a.getSeconds();
		  var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
		  return time;
		}
		
	},
	
	
};
</script>

<style lang="scss" scoped>
@import './_index/index.scss';
</style>

<style lang="scss">
.count-down {
	span {
		display: inline-block;
		width: 22px;
		height: 22px;
		line-height: 22px;
		text-align: center;
		background: #383838;
		color: #ffffff;
		border-radius: 2px;
	}
}.index{
    width: 1443px !important;
    margin: 0 auto !important;
    padding-left: 0px !important;
	}
	
	
	
	
	@media all {
		*,
		::after,
		::before {
			box-sizing: border-box;
		}
		a {
			color: #007bff;
			text-decoration: none;
			background-color: transparent;
		}
		a:hover {
			color: #0056b3;
			text-decoration: underline;
		}
		a:not([href]):not([tabindex]) {
			color: inherit;
			text-decoration: none;
		}
		a:not([href]):not([tabindex]):focus,
		a:not([href]):not([tabindex]):hover {
			color: inherit;
			text-decoration: none;
		}
		a:not([href]):not([tabindex]):focus {
			outline: 0;
		}
		@media print {
			*,
			::after,
			::before {
				text-shadow: none!important;
				box-shadow: none!important;
			}
			a:not(.btn) {
				text-decoration: underline;
			}
		}
	}
	
	
	/*! CSS Used from: https://www.mercular.com/css/front/seed/seed.css ; media=all */
	
	@media all {
		a {
			background-color: transparent;
		}
		a:active,
		a:hover {
			outline: 0;
		}
		*,
		*:before,
		*:after {
			-moz-box-sizing: border-box;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;
		}
		a,
		a:hover {
			text-decoration: none;
		}
	}
	
	
	/*! CSS Used from: https://www.mercular.com/css/front/style.css?build=638c8b7076974f48e1681bc048f96a5a02a294c8 ; media=all */
	
	@media all {
		a {
			color: #3f4d56;
			-webkit-transition: 300ms;
			-moz-transition: 300ms;
			-o-transition: 300ms;
			transition: 300ms;
		}
		a.link {
			color: #0690f0;
		}
		a.link:hover {
			color: #0572be;
		}
	}
	
	
	/*! CSS Used from: https://www.mercular.com/css/front/styles-new.css?build=638c8b7076974f48e1681bc048f96a5a02a294c8 ; media=all */
	
	@media all {
		*:not(body) {
			-webkit-tap-highlight-color: transparent;
			-ms-overflow-style: none;
			scrollbar-width: none;
		}
		div {
			border: 0;
			margin: 0;
			padding: 0;
		}
		a {
			border: 0;
			font-size: 100%;
			vertical-align: baseline;
			margin: 0;
			padding: 0;
		}
		
	
		a {
			cursor: pointer;
		}
		a {
			text-decoration: none;
			color: #1B1B1B;
		}
		:focus {
			outline: 0;
		}
		
		.coupon___cart__flex {
			display: inline-flex;
			flex-direction: column;
			overflow: hidden;
			min-width: 200px;
			margin: 10px;
			position: relative;
		}
		.coupon___cart__top {
			float: left;
			width: 200px;
			height: 170px;
			position: relative;
			background: #ffffff;
			border-left: 1px solid #e8e8e8;
			border-top: 1px solid #e8e8e8;
			border-right: 1px solid #e8e8e8;
			border-radius: 10px;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 20px 6px 29px 6px;
		}
		.coupon___cart__top .circle-coupon__top {
			height: 20px;
			width: 20px;
			background: #fafafa;
			position: absolute;
			border-radius: 50%;
			bottom: -10px;
			z-index: 1;
			border: 1px solid #e8e8e8;
		}
		.coupon___cart__top .circle-coupon__top.circle__left {
			left: -10px;
		}
		.coupon___cart__top .circle-coupon__top.circle__right {
			left: 190px;
		}
		.coupon___cart__top .got-coupon-card__top {
			display: flex;
			flex-direction: column;
			align-items: center;
			height: 140px;
		}
		.coupon___cart__top .got-coupon-card__top .coupon-headers {
			font-weight: bold;
			font-size: 26px;
			color: #e31f26;
			height: 28px;
		}
		.coupon___cart__top .got-coupon-card__top .coupon-price {
			font-weight: bold;
			font-size: 34px;
			color: #000000;
			height: 56px;
			display: flex;
			align-items: center;
		}
		@media (max-width: 1024px) {
			.coupon___cart__top .got-coupon-card__top .coupon-price {
				font-size: 24px;
			}
		}
		.coupon___cart__top .got-coupon-card__top .coupon-description {
			font-size: 12px;
			width: 180px;
			height: auto;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-align: center;
		}
		.coupon___cart__top .got-coupon-card__top .coupon-description-2 {
			-webkit-line-clamp: 1;
		}
		.coupon___cart__bottom {
			float: left;
			width: 200px;
			height: 78px;
			position: relative;
			background: #e31f26;
			border-left: 1px solid #e8e8e8;
			border-right: 1px solid #e8e8e8;
			border-bottom: 1px solid #e8e8e8;
			border-radius: 10px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.coupon___cart__bottom .got-coupon-card__bottom {
			width: 130px;
			height: 44px;
			background-color: #fff;
			border-radius: 22px;
			display: flex;
			justify-content: center;
		}
		.coupon___cart__bottom .got-coupon-card__bottom .got__coupon__bottom {
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.coupon-text {
			font-size: 16px;
			font-weight: bold;
			color: #1b1b1b;
		}
		@media (max-width: 1024px) {
			.coupon___cart__top {
				width: 128px;
				height: 108.56px;
			}
			.coupon___cart__flex {
				min-width: 128px;
				margin: 10px;
			}
			.coupon___cart__top .circle-coupon__top.circle__right {
				left: 117px;
			}
			.coupon___cart__bottom {
				width: 128px;
				height: 49.78px;
			}
			.coupon___cart__bottom {
				float: left;
			}
			.coupon___cart__bottom .got-coupon-card__bottom {
				width: 103px;
				height: 32px;
			}
			.coupon___cart__bottom .got-coupon-card__bottom .got__coupon__bottom {
				display: flex;
				justify-content: center;
				align-items: center;
			}
			.coupon___cart__top {
				padding: 0px;
			}
			.coupon___cart__top .circle-coupon__top {
				background-color: #fff;
			}
			.coupon___cart__top .got-coupon-card__top {
				height: 100%;
				justify-content: center;
			}
			.coupon___cart__top .got-coupon-card__top .coupon-headers {
				font-weight: bold;
				font-size: 16px;
				height: 20px;
			}
			.coupon___cart__top .got-coupon-card__top .coupon-description {
				width: 110px;
				font-size: 8px;
				height: auto;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				overflow: hidden;
				text-align: center;
			}
			.coupon-text {
				font-size: 14px;
			}
		}
	}
	
	
	/*! CSS Used fontfaces */
	
	
@media all {
	*,
	::after,
	::before {
		box-sizing: border-box;
	}
	a {
		color: #007bff;
		text-decoration: none;
		background-color: transparent;
	}
	a:hover {
		color: #0056b3;
		text-decoration: underline;
	}
	a:not([href]):not([tabindex]) {
		color: inherit;
		text-decoration: none;
	}
	a:not([href]):not([tabindex]):focus,
	a:not([href]):not([tabindex]):hover {
		color: inherit;
		text-decoration: none;
	}
	a:not([href]):not([tabindex]):focus {
		outline: 0;
	}
	.container {
		width: 100%;
		padding-right: 15px;
		padding-left: 15px;
		margin-right: auto;
		margin-left: auto;
	}

		.container {
			max-width: 1540px;
		}
	
	.row {
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-right: -15px;
		margin-left: -15px;
	}
	@media print {
		*,
		::after,
		::before {
			text-shadow: none!important;
			box-shadow: none!important;
		}
		a:not(.btn) {
			text-decoration: underline;
		}
		.container {
			min-width: 992px!important;
		}
	}
}


/*! CSS Used from: https://www.mercular.com/css/front/seed/seed.css ; media=all */

@media all {
	a {
		background-color: transparent;
	}
	a:active,
	a:hover {
		outline: 0;
	}
	*,
	*:before,
	*:after {
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
	.container {
		padding-right: 15px;
		padding-left: 15px;
		margin-right: auto;
		margin-left: auto;
	}
	.row {
		margin-right: -15px;
		margin-left: -15px;
	}
	.row:before,
	.row:after {
		content: "";
		display: table;
	}
	.row:after {
		clear: both;
	}
	a,
	a:hover {
		text-decoration: none;
	}
}


/*! CSS Used from: https://www.mercular.com/css/front/style.css?build=638c8b7076974f48e1681bc048f96a5a02a294c8 ; media=all */

@media all {
	a {
		color: #3f4d56;
		-webkit-transition: 300ms;
		-moz-transition: 300ms;
		-o-transition: 300ms;
		transition: 300ms;
	}
	a.link {
		color: #0690f0;
	}
	a.link:hover {
		color: #0572be;
	}
	#content .container {
		padding: 0px 0px;
	}
	.container {
		margin: auto;
	}

}


/*! CSS Used from: https://www.mercular.com/css/front/styles-new.css?build=638c8b7076974f48e1681bc048f96a5a02a294c8 ; media=all */

@media all {
	*:not(body) {
		-webkit-tap-highlight-color: transparent;
		-ms-overflow-style: none;
		scrollbar-width: none;
	}
	div {
		border: 0;
		margin: 0;
		padding: 0;
	}
	a {
		border: 0;
		font-size: 100%;
		vertical-align: baseline;
		margin: 0;
		padding: 0;
	}
	
	a {
		cursor: pointer;
	}
	a {
		text-decoration: none;
		color: #1B1B1B;
	}
	:focus {
		outline: 0;
	}
	
	@media (max-width: 1024px) {
		#content .container {
			padding-left: 0px;
			padding-right: 0px;
		}
	}
	.d-flex-center {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.content-json-container .main-section .content-block.coupon_list .coupon-list-wrapper {
		display: inline-grid;
		margin: auto;
		padding: 15px;
		text-align: center;
		grid-template-columns: auto auto auto auto;
	}
	@media (max-width: 585px) {
		.content-json-container .main-section .content-block.coupon_list .coupon-list-wrapper {
			grid-template-columns: auto auto auto;
		}
	}
	@media (max-width: 441px) {
		.content-json-container .main-section .content-block.coupon_list .coupon-list-wrapper {
			grid-template-columns: auto auto;
		}
	}
	.coupon___cart__flex {
		display: inline-flex;
		flex-direction: column;
		overflow: hidden;
		min-width: 200px;
		margin: 10px;
		position: relative;
	}
	.coupon___cart__top {
		float: left;
		width: 200px;
		height: 170px;
		position: relative;
		background: #ffffff;
		border-left: 1px solid #e8e8e8;
		border-top: 1px solid #e8e8e8;
		border-right: 1px solid #e8e8e8;
		border-radius: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 20px 6px 29px 6px;
	}
	.coupon___cart__top .circle-coupon__top {
		height: 20px;
		width: 20px;
		background: #fafafa;
		position: absolute;
		border-radius: 50%;
		bottom: -10px;
		z-index: 1;
		border: 1px solid #e8e8e8;
	}
	.coupon___cart__top .circle-coupon__top.circle__left {
		left: -10px;
	}
	.coupon___cart__top .circle-coupon__top.circle__right {
		left: 190px;
	}
	.coupon___cart__top .got-coupon-card__top {
		display: flex;
		flex-direction: column;
		align-items: center;
		height: 140px;
	}
	.coupon___cart__top .got-coupon-card__top .coupon-headers {
		font-weight: bold;
		font-size: 26px;
		color: #e31f26;
		height: 28px;
	}
	.coupon___cart__top .got-coupon-card__top .coupon-price {
		font-weight: bold;
		font-size: 34px;
		color: #000000;
		height: 56px;
		display: flex;
		align-items: center;
	}
	@media (max-width: 1024px) {
		.coupon___cart__top .got-coupon-card__top .coupon-price {
			font-size: 24px;
		}
	}
	.coupon___cart__top .got-coupon-card__top .coupon-description {
		font-size: 12px;
		width: 180px;
		height: auto;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-align: center;
	}
	.coupon___cart__top .got-coupon-card__top .coupon-description-2 {
		-webkit-line-clamp: 1;
	}
	.coupon___cart__bottom {
		float: left;
		width: 200px;
		height: 78px;
		position: relative;
		background: #e31f26;
		border-left: 1px solid #e8e8e8;
		border-right: 1px solid #e8e8e8;
		border-bottom: 1px solid #e8e8e8;
		border-radius: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.coupon___cart__bottom .got-coupon-card__bottom {
		width: 130px;
		height: 44px;
		background-color: #fff;
		border-radius: 22px;
		display: flex;
		justify-content: center;
	}
	.coupon___cart__bottom .got-coupon-card__bottom .got__coupon__bottom {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.coupon-text {
		font-size: 16px;
		font-weight: bold;
		color: #1b1b1b;
	}
	.coupon-claimed {
		width: 200px;
		height: 248px;
		background: #000000a8;
		position: absolute;
		border-radius: 8px;
		pointer-events: none;
	}
	.coupon-claimed .text-claimed {
		width: 108px;
		height: auto;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 6px;
		transform: rotate(335deg);
		font-size: 18px;
		font-weight: bold;
		color: #858585;
		text-align: center;
		padding: 8px;
	}
	@media (max-width: 1024px) {
		.coupon-claimed .text-claimed {
			font-size: 16px;
			padding: 4px;
		}
	}
	@media (max-width: 1024px) {
		.coupon___cart__top {
			width: 128px;
			height: 108.56px;
		}
		.coupon___cart__flex {
			min-width: 128px;
			margin: 10px;
		}
		.coupon-claimed {
			width: 128px;
			height: 158.34px;
		}
		.coupon___cart__top .circle-coupon__top.circle__right {
			left: 117px;
		}
		.coupon___cart__bottom {
			width: 128px;
			height: 49.78px;
		}
		.coupon___cart__bottom {
			float: left;
		}
		.coupon___cart__bottom .got-coupon-card__bottom {
			width: 103px;
			height: 32px;
		}
		.coupon___cart__bottom .got-coupon-card__bottom .got__coupon__bottom {
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.coupon___cart__top {
			padding: 0px;
		}
		.coupon___cart__top .circle-coupon__top {
			background-color: #fff;
		}
		.coupon___cart__top .got-coupon-card__top {
			height: 100%;
			justify-content: center;
		}
		.coupon___cart__top .got-coupon-card__top .coupon-headers {
			font-weight: bold;
			font-size: 16px;
			height: 20px;
		}
		.coupon___cart__top .got-coupon-card__top .coupon-description {
			width: 110px;
			font-size: 8px;
			height: auto;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-align: center;
		}
		.coupon-text {
			font-size: 14px;
		}
	}
	.content-json-container {
		width: 100%!important;
	}
	.content-json-container .main-section {
		margin: auto;
		width: 1240px;
	}
	@media (max-width: 1240px) {
		.content-json-container .main-section {
			width: 970px;
		}
	}
	@media (max-width: 1240px) and (max-width: 1024px) {
		.content-json-container .main-section {
			width: 100%;
		}
	}
	@media (max-width: 991px) {
		.content-json-container .main-section {
			width: 100%;
			padding: 0px;
		}
	}
}


/*! CSS Used from: https://www.mercular.com/css/front/content-json/main.css?build=638c8b7076974f48e1681bc048f96a5a02a294c8 ; media=all */

@media all {
	.content-json-container {
		background-position: center top;
		background-size: 1920px auto;
		background-repeat: no-repeat;
	}
	.content-json-container .main-section {
		padding: 0px;
	}
	.content-json-container .main-section .content-json-target {
		display: block;
		visibility: hidden;
		top: -200px;
		position: relative;
	}
	.content-json-container .main-section .content-block.coupon_list {
		text-align: center;
	}
	.content-json-container .main-section .content-block.coupon_list .coupon-list-wrapper {
		display: inline-block;
		margin: auto;
		padding: 15px;
		text-align: center;
	}
	@media (max-width: 991px) {
		.content-json-container .main-section {
			width: 100%;
			padding: 0px;
		}
		.content-json-container .main-section .content-block.coupon_list .coupon-list-wrapper {
			padding-left: 5px;
			padding-right: 5px;
		}
	}
}


/*! CSS Used fontfaces */

@media all {
	*,
	::after,
	::before {
		box-sizing: border-box;
	}
	a {
		color: #007bff;
		text-decoration: none;
		background-color: transparent;
	}
	a:hover {
		color: #0056b3;
		text-decoration: underline;
	}
	a:not([href]):not([tabindex]) {
		color: inherit;
		text-decoration: none;
	}
	a:not([href]):not([tabindex]):focus,
	a:not([href]):not([tabindex]):hover {
		color: inherit;
		text-decoration: none;
	}
	a:not([href]):not([tabindex]):focus {
		outline: 0;
	}
	img {
		vertical-align: middle;
		border-style: none;
	}
	.container {
		width: 100%;
		padding-right: 15px;
		padding-left: 15px;
		margin-right: auto;
		margin-left: auto;
	}
	
	.row {
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-right: -15px;
		margin-left: -15px;
	}
	@media print {
		*,
		::after,
		::before {
			text-shadow: none!important;
			box-shadow: none!important;
		}
		a:not(.btn) {
			text-decoration: underline;
		}
		img {
			page-break-inside: avoid;
		}
		.container {
			min-width: 992px!important;
		}
	}
}


/*! CSS Used from: https://www.mercular.com/css/front/seed/seed.css ; media=all */

@media all {
	a {
		background-color: transparent;
	}
	a:active,
	a:hover {
		outline: 0;
	}
	img {
		border: 0;
	}
	*,
	*:before,
	*:after {
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
	.container {
		padding-right: 15px;
		padding-left: 15px;
		margin-right: auto;
		margin-left: auto;
	}
	.row {
		margin-right: -15px;
		margin-left: -15px;
	}
	.row:before,
	.row:after {
		content: "";
		display: table;
	}
	.row:after {
		clear: both;
	}
	img {
		max-width: 100%;
		height: auto;
	}
	a,
	a:hover {
		text-decoration: none;
	}
}


/*! CSS Used from: https://www.mercular.com/css/front/style.css?build=638c8b7076974f48e1681bc048f96a5a02a294c8 ; media=all */

@media all {
	a {
		color: #3f4d56;
		-webkit-transition: 300ms;
		-moz-transition: 300ms;
		-o-transition: 300ms;
		transition: 300ms;
	}
	#content .container {
		padding: 0px 0px;
	}
	.container {
		margin: auto;
	}
	
}


/*! CSS Used from: https://www.mercular.com/css/front/styles-new.css?build=638c8b7076974f48e1681bc048f96a5a02a294c8 ; media=all */

@media all {
	*:not(body) {
		-webkit-tap-highlight-color: transparent;
		-ms-overflow-style: none;
		scrollbar-width: none;
	}
	div,
	img {
		border: 0;
		margin: 0;
		padding: 0;
	}
	a {
		border: 0;
		font-size: 100%;
		vertical-align: baseline;
		margin: 0;
		padding: 0;
	}
	
	a {
		cursor: pointer;
	}
	a {
		text-decoration: none;
		color: #1B1B1B;
	}
	:focus {
		outline: 0;
	}
	
	@media (max-width: 1024px) {
		#content .container {
			padding-left: 0px;
			padding-right: 0px;
		}
	}
	.content-json-container {
		width: 100%!important;
	}
	.content-json-container .main-section {
		margin: auto;
		width: 1240px;
	}
	@media (max-width: 1240px) {
		.content-json-container .main-section {
			width: 970px;
		}
	}
	@media (max-width: 1240px) and (max-width: 1024px) {
		.content-json-container .main-section {
			width: 100%;
		}
	}
	@media (max-width: 991px) {
		.content-json-container .main-section {
			width: 100%;
			padding: 0px;
		}
	}
}


/*! CSS Used from: https://www.mercular.com/css/front/content-json/main.css?build=638c8b7076974f48e1681bc048f96a5a02a294c8 ; media=all */

@media all {
	.content-json-container {
		background-position: center top;
		background-size: 1920px auto;
		background-repeat: no-repeat;
	}
	.content-json-container .main-section {
		padding: 0px;
	}
	.content-json-container .main-section .content-json-target {
		display: block;
		visibility: hidden;
		top: -200px;
		position: relative;
	}
	.content-json-container .main-section .content-block.image img {
		width: 100%;
		position: relative;
		left: 50%;
		transform: translateX(-50%);
	}
	@media (max-width: 991px) {
		.content-json-container .main-section {
			width: 100%;
			padding: 0px;
		}
	}
}


/*! CSS Used fontfaces */

@media all {
	*,
	::after,
	::before {
		box-sizing: border-box;
	}
	b {
		font-weight: bolder;
	}
	a {
		color: #007bff;
		text-decoration: none;
		background-color: transparent;
	}
	a:hover {
		color: #0056b3;
		text-decoration: underline;
	}
	img {
		vertical-align: middle;
		border-style: none;
	}
	@media print {
		*,
		::after,
		::before {
			text-shadow: none!important;
			box-shadow: none!important;
		}
		a:not(.btn) {
			text-decoration: underline;
		}
		img {
			page-break-inside: avoid;
		}
	}
}


@media screen{
div{margin:0;padding:0;}
img{border:0;}
a{color:#f73173;text-decoration:none;}
a:hover{text-decoration:underline;}
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/j/j.v4.85.min.css?v=1626429966 ; media=screen */
@media screen{
div,ul,li{margin:0;padding:0;}
img{border:0;}
ul li{list-style:none;}
a{color:#f73173;text-decoration:none;}
a:hover{text-decoration:underline;}
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/head_foot.min.css?v=1664360752 */
ul,li{list-style:none;}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/index.min.css?v=1654680463 ; media=screen */
@media screen{
div,ul,li{margin:0;padding:0;}
img{border:0;}
li{list-style:none;}
a{text-decoration:none;}
a:hover{text-decoration:underline;}
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/utils/css/ky.min.css?v=1664420402 */
*{padding:0;margin:0;box-sizing:content-box;}
li,ul{list-style:none;}
img{border:none;}
a:hover,a{text-decoration:none;}
a{color:#333;}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/admin/adminbrand_flagship.min.css?v=1665338270 */
*{margin:0;padding:0;-webkit-text-size-adjust:none;}
li,ul{list-style:none;}
a{text-decoration:none;color:#333;}
img{vertical-align:middle;}
.ContentShow img{border:none;display:inline-block;overflow:hidden;max-width:100%;}
.ContentShow{width:1180px;margin:0 auto;display:none;color:#333;}
.LeftClickLi>.module_banner>li{margin-bottom:1.35%;}
.LeftClickLi>.module_banner>li:last-child{margin-bottom:0;}
.ContentShow .LeftClickLi{padding-bottom:0.1px;}
.moduleWarp{overflow:hidden;}
.LeftClickLi img{width:100%;display:block;overflow:hidden;}
.AllWarp .LeftClickLi img{vertical-align:middle;width:100%;}
.ContentShow .LeftClickLi li{overflow:hidden;}
.module_banner>li{position:relative;}
.ContentShow .li-nohover:hover{box-shadow:none;}
.ContentShow .li-nohover a{cursor:initial;}
.over-in>li{overflow:inherit!important;height:auto!important;}
@media (max-width:1440px){
.ContentShow{width:1000px;}
}
@media (max-width:1360px){
.ContentShow{width:950px;}
}
.ContentShow{position:relative;}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/web/promo_new.min.css?v=1661745912 */
.ContentShow img{max-width:100%;}
@media (max-width:1440px){
.ContentShow{width:950px;}
}
.moduleWarp{display:none;}
.moduleWarp>.ContentShow{display:block;position:relative;}/*! CSS Used from: https://s2.konvy.com/static/min/css/j/j.v4.85.min.css?v=1626429966 ; media=screen */
@media screen{
div,ul,li,p{margin:0;padding:0;}
img{border:0;}
ul li{list-style:none;}
a{color:#f73173;text-decoration:none;}
a:hover{text-decoration:underline;}
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/head_foot.min.css?v=1664360752 */
.New_clear:after{content:".";display:block;height:0;visibility:hidden;clear:both;}
.New_clear{zoom:1;}
.New_clear{zoom:1;}
ul,li{list-style:none;}
i{font-style:normal;}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/index.min.css?v=1654680463 ; media=screen */
@media screen{
div,ul,li,p{margin:0;padding:0;}
img{border:0;}
li{list-style:none;}
a{text-decoration:none;}
a:hover{text-decoration:underline;}
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/utils/css/ky.min.css?v=1664420402 */
*{padding:0;margin:0;box-sizing:content-box;}
li,ul{list-style:none;}
img{border:none;}
a:hover,a{text-decoration:none;}
a{color:#333;}
i{font-style:normal;}
.ky-text-regular{color:#666;}
.ky-lh-1{line-height:1;}
.ky-d-ib{display:inline-block;}
.ky-float-r{float:right;}
.ky-v-top{vertical-align:top;}
.ky-limit-one{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.ky-limit-more{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;-webkit-line-clamp:2;}
.ky-money{font-family:'Tahoma'!important;vertical-align:baseline;line-height:1;font-size:80%;}
.ky-pos{position:relative;}
/*! CSS Used from: https://s2.konvy.com/static/min/css/pc/css/konvy.min.css?v=1658495404 */
.moduleWarp .coupon-module-warp{padding-left:20px;}
.coupon-module-warp>ul{display:flex;flex-wrap:wrap;box-sizing:border-box;}
.coupon-module-warp li.ky-coupon-item{position:relative;}
.coupon-module-warp li.ky-coupon-item{width:366px;}
.adv_module_43>span{background-repeat:no-repeat!important;height:100%!important;}
.adv_module_43>span.adv_module_43_bg_left{width:408px;}
.adv_module_43>span.adv_module_43_bg_right{background-position:right bottom!important;}
.ky-coupon-item{position:relative;display:flex;background-color:#fff;margin:0 20px 20px 0;width:366px;}
.ky-coupon-item img{max-width:100%;}
.ky-coupon-item-margin{margin:-1.0928% -1.6396% -2.1857%;}
.ky-coupon-cont{position:absolute;padding:1.0928% 1.6396% 2.1857%;width:100%;height:100%;box-sizing:content-box;display:flex;color:#333;top:-2.5%;}
.ky-coupon-l{width:24.56%;position:relative;text-align:center;height:100%;border-radius:.21334rem;overflow:hidden;}
.ky-coupon-logo{width:90%;font-size:0;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}
.ky-coupon-logo{width:calc((100% - 12px));}
.ky-coupon-r{width:calc(75.14% + 2px);padding-left:10px;position:relative;box-sizing:border-box;}
.ky-coupon-r-cont{height:calc(100% - 31px);display:flex;}
.ky-coupon-type{padding-top:13px;font-weight:bold;line-height:36px;display:flex;align-items:baseline;}
.ky-coupon-type>span{font-size:20px;}
.ky-coupon-type>span.ky-coupon-deduct{font-size:28px;}
.ky-coupon-type>span.ky-coupon-deduct>span{font-size:20px;}
.ky-coupon-period-text{font-size:12px;line-height:14px;margin-top:2px;width:100%;}
.ky-coupon-condition-wrap{position:absolute;bottom:8px;left:0;width:100%;height:18px;overflow:hidden;display:flex;flex-wrap:wrap;}
.ky-coupon-condition-wrap>span{border:1px solid #F73173;color:#F73173;line-height:15px;font-size:12px;display:inline-block;padding:0 4px;max-width:100%;box-sizing:border-box;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-top:1px;vertical-align:top;margin-right:4px;}
.ky-coupon-condition-wrap>span:last-child{margin-right:0;}
.ky-coupon-participant{color:#999;font-size:12px;line-height:14px;position:absolute;bottom:8px;padding:0 5px;width:100%;box-sizing:border-box;letter-spacing:-.2px;}
.coupon-module-warp li.ky-coupon-item{background-color:transparent;box-shadow:none;overflow:initial;}
.ky-coupon-rl-wrap{width:calc(100% - 110px);position:relative;height:100%;}
.ky-coupon-rr-wrap{width:32.67%;padding:0 13px 0 10px;display:flex;flex-wrap:wrap;align-items:center;align-content:center;}
.ky-coupon-button{width:100%;height:32px;line-height:32px;font-size:14px;font-weight:bold;text-align:center;display:block;background:#F73173;border-radius:32px;color:#fff;position:relative;z-index:2;cursor:pointer;}
.ky-coupon-period{font-size:12px;border-top:1px solid rgba(0,0,0,.08);padding:8px 0;line-height:1;color:#999;position:absolute;bottom:0;width:calc(100% - 23px);box-sizing:border-box;line-height:14px;cursor:pointer;}
.ky-coupon-period>span{width:calc(100% - 30px);display:inline-block;vertical-align:top;}
.ky-coupon-more{cursor:pointer;}
.ky-coupon-more:hover .ky-coupon-more-fixed{display:block;}
.ky-coupon-more:hover .ky-coupon-more-icon{transform:rotate(360deg);}
.ky-coupon-more-icon{width:14px;height:14px;display:inline-block;background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAeFJREFUSEu9lj1LQlEYx38iRGFDRIJGk1MFYkvlENF1aG1oa+o7CE4NDk2Cn6GtrS/QoA0NVsuNpJqcIgUlGuyF6GI84onb7V7vuSr3rOd/nt95Xs+JoLfmgEVgAZgGZgbHPoBPoAM8A69+5iI+giVgFZj1MzTY7wL3wJOX3gsYA9aBeU2QU/YC3ABvzg03YBzYBKZGhKljX8AV0LbbcQIFtgX4hVr3Lj3g0g61G5YwGhPwzHkZ8bSqwmsH7oyRMz+PJacXIlJAqcYNv1NqP5VKSWvQaDSkJXTXtVSvAu7qlr7AarXakVCy2exxAKi0zLkApalzOtdUsHg8viL6drv9EBBaEaA09rIf0AlT+oDQRwFuD0aWJ9MJq1arpyI2DOMgoKcdAQ7Nnxssl8udCahSqewHhHYFuAdE3dwbBlP6gFDLE6gDGwH67RnSZrNZTCQSaTEqOVNh9Eq03dNWq3WXTCaLLtp+SP8VTSaTiZmmeSKh1oG5eGql0+nDer3+7oD2i8a1LUqlUiYajUby+bzp1zL2/XK5vGZZVq9QKNy6nOu3hXbjBwF7aPuNL0t7tI0B/R1tYiPQ8B4R+md4i41QnycBhv4ACzTUL4ZKTaifKAUN9ZtoL8LQPsLOyp/YV/8HxVndNmCgpiUAAAAASUVORK5CYII=') no-repeat;background-size:100%;transform:rotate(180deg);transition:.3s;vertical-align:top;}
.ky-coupon-more-fixed{position:absolute;left:50%;margin-left:-150px;top:100%;width:300px;padding-top:14px;display:none;z-index:34;cursor:auto;}
.ky-coupon-more-wrap{background-color:#fff;border-radius:6px;box-shadow:0px 0px 12px 0px rgba(0,0,0,0.24);padding:13px;box-sizing:border-box;color:#333;line-height:18px;font-size:13px;}
.ky-coupon-more-wrap::after{content:'';width:0;height:0;top:3px;left:50%;-webkit-transform:translate(-50%,0%);transform:translate(-50%,00%);-ms-transform:translate(-50%,0%);-moz-transform:translate(-50%,0%);-o-transform:translate(-50%,0%);border-width:0 7px 7px;border-style:solid;border-color:transparent transparent #fff;position:absolute;top:7px;}
.ky-coupon-more-wrap>ul>li{padding-left:13px;margin-bottom:12px;position:relative;}
.ky-coupon-more-wrap>ul>li::after{content:'';position:absolute;left:1px;top:6px;width:5px;height:5px;background-color:#999;border-radius:5px;}
.ky-coupon-more-wrap>ul>li:last-child{margin-bottom:0;}
.ky-coupon-more-wrap>ul>li>span{color:#999;margin-top:6px;display:inline-block;word-break:break-word;}
@media (max-width:1440px){
.moduleWarp .coupon-module-warp{padding-left:16px;}
.moduleWarp .coupon-module-warp li.ky-coupon-item{margin:0 16px 16px 0;}
.moduleWarp .coupon-module-warp li.ky-coupon-item{width:295px;}
.moduleWarp .ky-coupon-type>span{font-size:16px;}
.moduleWarp .ky-coupon-type>span.ky-coupon-deduct{font-size:20px;}
.ky-coupon-type>span.ky-coupon-deduct>span{font-size:14px;}
.moduleWarp .ky-coupon-rl-wrap{width:calc(100% - 88px);}
.moduleWarp .ky-coupon-rr-wrap{width:65px;}
.moduleWarp .ky-coupon-button{line-height:28px;height:28px;font-size:12px;letter-spacing:-.3px;}
.moduleWarp .ky-coupon-period-text.ky-limit-more{-webkit-line-clamp:1;white-space:nowrap;text-overflow:ellipsis;display:block;}
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/admin/adminbrand_flagship.min.css?v=1665338270 */
*{margin:0;padding:0;-webkit-text-size-adjust:none;}
li,ul{list-style:none;}
a{text-decoration:none;color:#333;}
img{vertical-align:middle;}
.New_clear:after{content:".";display:block;height:0;visibility:hidden;clear:both;}
.New_clear{zoom:1;}
.ContentShow img{border:none;display:inline-block;overflow:hidden;max-width:100%;}
.ContentShow{width:1180px;margin:0 auto;display:none;color:#333;}
.moduleWarp{overflow:hidden;}
@media (max-width:1440px){
.ContentShow{width:1000px;}
}
@media (max-width:1360px){
.ContentShow{width:950px;}
}
.ContentShow{position:relative;}
.adv_module_43{padding-top:22px;background-color:#fff3f5;position:relative;overflow:hidden;}
.adv_module_43>span{position:absolute;width:386px;height:383px;background-size:100%;}
.adv_module_43>span.adv_module_43_bg_left{background:url(https://s2.konvy.com/static/img/admin/module_coupon_new/bg_up.png);left:0;top:0;}
.adv_module_43>span.adv_module_43_bg_right{background:url(https://s2.konvy.com/static/img/admin/module_coupon_new/bg_down.png);right:0;bottom:0;}
@media (max-width:1440px){
.adv_module_43{padding-top:17px;}
}
@media (max-width:1360px){
.adv_module_43{padding-top:16px;}
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/web/promo_new.min.css?v=1661745912 */
.ContentShow img{max-width:100%;}
@media (max-width:1440px){
.ContentShow{width:950px;}
}
@media (max-width:1440px){
.adv_module_43{padding-top:16px;}
}
.moduleWarp{display:none;}
.moduleWarp>.ContentShow{display:block;position:relative;}
/*! CSS Used from: Embedded */
#module_632998,#couponModule_632998{overflow:visible;}.el-carousel__item h3 {
  color: #475669;
  opacity: 0.01;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(n) {
  background-color: #99a9bf00;opacity: 1;
}
.content .seckill-wrap {
    height: 376px;
    width: 1410px;
    background-color: #ffffff;
    margin: 92px auto;
    border: 1px solid #e9e9e9;
    border-radius: 25px;
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/j/j.v4.85.min.css?v=1626429966 ; media=screen */
@media screen{
div,ul,li,p{margin:0;padding:0;}
img{border:0;}
ul li{list-style:none;}
a{color:#f73173;text-decoration:none;}
a:hover{text-decoration:underline;}
.clear{clear:both;}
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/head_foot.min.css?v=1664360752 */
.clear:after{content:".";display:block;height:0;visibility:hidden;clear:both;}
ul,li{list-style:none;}
.TeamGiveaway{position:absolute;right:5px;bottom:0;width:27%;z-index:1;background:white;}
.TeamGiveaway>p{line-height:2;background-color:#8bd9ff;color:#1c425c;text-shadow:2px 1px 0px #fff;font-size:14px;text-align:center;}
.TeamGiveaway>img,.ContentShow .TeamGiveaway>img{border-left:1px solid #ededed;border-right:1px solid #ededed;border-bottom:1px solid #ededed;box-sizing:border-box;}
@media (max-width:1440px){
.TeamGiveaway{right:3px;width:26%;}
.TeamGiveaway>p{font-size:12px;line-height:1.5;}
}
.limit_one{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.ContentShow .TeamGiveaway>img{width:40px;height:40px;border:solid 1px #ddd;border-radius:20px;}
i{font-style:normal;}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/index.min.css?v=1654680463 ; media=screen */
@media screen{
div,ul,li,p{margin:0;padding:0;}
img{border:0;}
li{list-style:none;}
a{text-decoration:none;}
a:hover{text-decoration:underline;}
.clear{clear:both;}
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/utils/css/ky.min.css?v=1664420402 */
*{padding:0;margin:0;box-sizing:content-box;}
li,ul{list-style:none;}
img{border:none;}
a:hover,a{text-decoration:none;}
a{color:#333;}
i{font-style:normal;}
/*! CSS Used from: https://s2.konvy.com/static/css/admin/swiper.min.css */
.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-transition-property:-webkit-transform;-moz-transition-property:-moz-transform;-o-transition-property:-o-transform;-ms-transition-property:-ms-transform;transition-property:transform;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;}
.swiper-wrapper{-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);-o-transform:translate(0,0);-ms-transform:translate3d(0,0,0);transform:translate3d(0,0,0);}
.swiper-slide{-webkit-flex-shrink:0;-ms-flex:0 0 auto;flex-shrink:0;width:100%;height:100%;position:relative;}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/admin/adminbrand_flagship.min.css?v=1665338270 */
*{margin:0;padding:0;-webkit-text-size-adjust:none;}
li,ul{list-style:none;}
.fr{float:right;}
a{text-decoration:none;color:#333;}
img{vertical-align:middle;}
.clear:after{content:".";display:block;height:0;visibility:hidden;clear:both;}
.clear{zoom:1;}
.ContentShow img{border:none;display:inline-block;overflow:hidden;max-width:100%;}
.ContentShow{width:1180px;margin:0 auto;display:none;color:#333;}
.moduleWarp{overflow:hidden;}
.line-clamp2{text-overflow:ellipsis;display:-webkit-box!important;;-webkit-line-clamp:2;-webkit-box-orient:vertical;font-weight:normal;}
@media (max-width:1440px){
.ContentShow{width:1000px;}
}
@media (max-width:1360px){
.ContentShow{width:950px;}
}
.ContentShow{position:relative;}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/web/promo.min.css?v=1644478071 */
.clear:after{content:".";display:block;height:0;visibility:hidden;clear:both;}
.clear{zoom:1;}
.pro_layout_icon{background:url(data:image/png;base64,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);width:20px;height:20px;}
.product_atc{overflow:hidden;text-align:center;margin-top:7px;}
.product_atc>a{font-size:14px;display:block;text-decoration:none;transition:0.5s;color:white;line-height:20px;padding:7px 0;border:1px white solid;opacity:0;}
.product_atc>a>i{margin-right:5px;vertical-align:bottom;display:inline-block;}
.product_atc>a.add_to_cart>i{background-position:0 -40px;}
/*! CSS Used from: Embedded */
@media (max-width: 1440px){
.ContentShow{width:1000px;padding-left:0;}
}
@media (max-width: 1360px){
.ContentShow{width:950px;padding-left:0;}
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/web/promo_new.min.css?v=1661745912 */
.ContentShow img{max-width:100%;}
@media (max-width:1440px){
.ContentShow{width:950px;}
}
.product_atc{margin-top:7px;position:relative;z-index:2;}
.product_atc>a.add_to_cart>i{display:none;}
.product_atc>a>i{vertical-align:middle;}
.product_atc>a{padding:0;height:40px;line-height:40px;box-sizing:border-box;}
.product_atc>a.add_to_cart>i{background-position:0 -41px;}
.TeamGiveaway{background-color:transparent;width:40px;}
.TeamGiveaway>p{background-color:transparent;text-shadow:#fff 1px 0 0,#fff 0 1px 0,#fff -1px 0 0,#fff 0 -1px 0;font-size:13px;color:#333;text-transform:uppercase;}
.TeamGiveaway>img,.ContentShow .TeamGiveaway>img{width:40px;height:40px;border:solid 1px #ddd;border-radius:20px;}
@media (max-width:1440px){
.product_atc>a{height:33px;line-height:33px;}
}
.limit_one{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.moduleWarp{display:none;}
.moduleWarp>.ContentShow{display:block;position:relative;}
.new-module-20-warp{position:relative;overflow:hidden;background-color:#fff;}
.module-20-bg{width:100%;height:250px;z-index:-1;position:absolute;left:0;top:0;z-index:0;}
.module-20-icon{width:240px;}
.module-20-time span{min-width:22px;height:26px;border:2px solid #fff;border-radius:6px;font-size:14px;font-weight:400;font-weight:initial;background-color:#333;color:#fff;display:inline-block;line-height:28px;text-align:center;padding:0 2px;}
.module-20-viewall{font-weight:400;font-style:italic;font-size:16px;line-height:1;text-decoration:underline;float:right;margin-top:14px;}
.K-team-right{padding-top:10px;}
.K-team-Image,.K-team-Image>img{width:100%;height:100%;display:inline-block;font-size:0;}
.K-team-list{position:relative;float:left;text-align:center;margin-right:12px;}
.K-team-list:last-child{margin-right:0;}
.K-team-list-pos-h{padding:10px;background-color:#fff;width:100%;border-radius:4px;border:1px solid #f7f7f7;min-height:100%;box-sizing:border-box;overflow:hidden;}
.K-team-list-hover{margin-bottom:12px;position:relative;}
.K-team-list-hover:last-child{margin-bottom:0;}
.K-team-list .money{font-size:12px;font-family:'Tahoma';font-weight:normal;font-style:normal;margin-right:2px;}
.K-team-list .K-team-discount{border-radius:8px;display:inline-block;font-size:12px;line-height:16px;color:#fff;text-align:center;font-weight:normal;}
.module-20-Head{padding-top:37px;padding-bottom:28px;position:relative;}
.module-20-Head .module-20-time{display:inline-block;margin:5px 22px 0px;vertical-align:top;}
.new-module-20-warp .K-team-Price{color:#6753A3;font-size:26px;font-weight:500;padding-top:2px;}
.new-module-20-warp .K-team-list .money{font-size:16px;}
.new-module-20-warp .line-clamp2{height:36px;line-height:18px;display:block;overflow:hidden;}
.new-module-20-warp .K-team-discount{width:40px;height:16px;background:rgba(103,83,163,.1);vertical-align:text-top;margin-top:8px;margin-left:8px;color:#6753A3;}
.new-module-20-warp .product_atc{display:none;margin-top:7px;}
.new-module-20-warp .product_atc>a{opacity:1;border:none;height:36px;line-height:36px;text-align:center;color:#fff;font-size:14px;background-color:#6753A3;border-radius:2px;}
.K-team-list-image{position:relative;display:inline-block;width:140px;height:140px;}
.k-team-prev-btn{left:-60px;background:url(https://s2.konvy.com/static/banner/module_image/pc/67/btn_left@2x.png) no-repeat;background-size:100%;}
.k-team-prev-btn:hover{background:url(https://s2.konvy.com/static/banner/module_image/pc/67/btn_left_hover@2x.png) no-repeat;background-size:100%;}
.k-team-next-btn{right:-60px;background:url(https://s2.konvy.com/static/banner/module_image/pc/67/btn_right@2x.png) no-repeat;background-size:100%;}
.k-team-next-btn:hover{background:url(https://s2.konvy.com/static/banner/module_image/pc/67/btn_right_hover@2x.png) no-repeat;background-size:100%;}
.k-team-prev-btn,.k-team-next-btn{position:absolute;width:40px;height:40px;top:54%;transform:translate(0,-50%);}
@media (max-width:1440px){
.module-20-bg{height:200px;}
.K-team-list-image{width:112px;height:112px;}
.module-20-Head img{width:193px;}
.module-20-viewall{font-size:13px;}
.new-module-20-warp .product_atc>a{line-height:29px;height:29px;font-size:12px;}
.new-module-20-warp .K-team-discount{margin-left:6px;}
.module-20-Head .module-20-time{margin-top:1px;}
}
.new-module-20-warp .brand_name{color:#999;font-size:12px;margin-bottom:4px;}
@media (max-width:1440px){
.new-module-20-warp .K-team-list{margin-right:10px;}
.new-module-20-warp .K-team-list:last-child{margin-right:0;}
.module-20-Head{padding-top:30px;padding-bottom:22px;}
}
.new-module-20-warp.list-countNum-5 .module-20-team{overflow:hidden;}
.new-module-20-warp.list-countNum-5 .K-team-list{width:226px;}
.new-module-20-warp.list-countNum-5 .K-team-list-hover{height:246px;}
@media (max-width:1440px){
.new-module-20-warp.list-countNum-5 .K-team-list{width:180px;}
.new-module-20-warp.list-countNum-5 .K-team-list-hover{height:218px;}
}
.new-module-20-warp.list-countNum-5 .module-20-team{padding-bottom:45px;}
.new-module-20-warp .K-team-list-hover:hover>.K-team-list-pos-h{position:absolute;box-shadow:0px 2px 11px 0px rgba(0,0,0,0.05);border-radius:4px;z-index:4;}
.new-module-20-warp .K-team-list-hover:hover .product_atc{display:block;}
@media (max-width:1440px){
.new-module-20-warp.list-countNum-5 .module-20-team{padding-bottom:42px;}
}
.finishedImage{display:none;background:url(https://s2.konvy.com/static/banner/image/icon/img_finished@2x.png) no-repeat;width:95px;height:95px;position:absolute;left:420px;background-size:100%;top:20px;z-index:9;pointer-events:none;}
.moduleCate.list-countNum-5 .K-team-list-pos-h{padding:0;padding-top:8px;}
.moduleCate.list-countNum-5 .K-team-right{padding:9px 10px;}
@media (max-width:1440px){
.finishedImage{left:368px;width:80px;height:80px;}
.moduleCate.list-countNum-5 .K-team-right{padding:6px 10px;}
}
.module-tag-warp{position:relative;}
.module-tag-warp .module-tag-style{margin-bottom:20px;width:calc(100% - 50px);overflow:hidden;}
.module-tag-warp .module-tag-style li{margin-right:50px;line-height:30px;font-size:14px;color:#333;border-bottom:2px solid transparent;float:left;width:auto;}
.module-tag-warp .module-tag-style li:last-child{margin-right:0;}
.module-tag-warp .module-tag-style li:hover{cursor:pointer;}
.module-tag-warp .module-tag-style li.active{font-weight:500;border-bottom:2px solid #333;}
.moduleCate .nextBtn{position:absolute;right:-50px;top:5px;width:20px;height:20px;background:url(https://s2.konvy.com/static/banner/image/icon/icon_right_normal@2x.png) no-repeat;background-size:20px;}
.moduleCate .nextBtn:hover{background-image:url(https://s2.konvy.com/static/banner/image/icon/icon_right_hover@2x.png);}
.moduleCate .cate-team-warp .K-team-list{margin-bottom:10px;}.ContentShow {
    width: 1386px;
    margin: 0 auto;
    display: none;
    color: #333;
}/*! CSS Used from: https://s2.konvy.com/static/min/css/j/j.v4.85.min.css?v=1626429966 ; media=screen */
@media screen{
div,ul,li{margin:0;padding:0;}
img{border:0;}
ul li{list-style:none;}
a{color:#f73173;text-decoration:none;}
a:hover{text-decoration:underline;}
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/head_foot.min.css?v=1664360752 */
ul,li{list-style:none;}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/index.min.css?v=1654680463 ; media=screen */
@media screen{
div,ul,li{margin:0;padding:0;}
img{border:0;}
li{list-style:none;}
a{text-decoration:none;}
a:hover{text-decoration:underline;}
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/utils/css/ky.min.css?v=1664420402 */
*{padding:0;margin:0;box-sizing:content-box;}
li,ul{list-style:none;}
img{border:none;}
a:hover,a{text-decoration:none;}
a{color:#333;}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/admin/adminbrand_flagship.min.css?v=1665338270 */
*{margin:0;padding:0;-webkit-text-size-adjust:none;}
li,ul{list-style:none;}
a{text-decoration:none;color:#333;}
img{vertical-align:middle;}
.ContentShow img{border:none;display:inline-block;overflow:hidden;max-width:100%;}
.ContentShow{width:1180px;margin:0 auto;display:none;color:#333;}
.ContentShow .RBigTitle{margin-bottom:1.35%;}
.moduleWarp{overflow:hidden;}
.RBigTitle img{margin:0 auto;}
.RBigTitle img{margin:0 auto;display:block;max-width:100%;max-height:100%;}
.ContentShow .RBigTitle li{overflow:hidden;}
.module_banner>li{position:relative;}
@media (max-width:1440px){
.ContentShow{width:1000px;}
}
@media (max-width:1360px){
.ContentShow{width:950px;}
}
.ContentShow{position:relative;}
/*! CSS Used from: Embedded */
@media (max-width: 1440px){
.ContentShow{width:1000px;padding-left:0;}
}
@media (max-width: 1360px){
.ContentShow{width:950px;padding-left:0;}
}
/*! CSS Used from: https://s2.konvy.com/static/min/css/css/web/promo_new.min.css?v=1661745912 */
.ContentShow img{max-width:100%;}
@media (max-width:1440px){
.ContentShow{width:950px;}
}
.ContentShow .RBigTitle{margin:0;}
.moduleWarp{display:none;}
.moduleWarp>.ContentShow{display:block;position:relative;}
.moduleWarp.isTitleWarp{padding:.1px;}
::-webkit-scrollbar-thumb {
      display: block;
}
.content .ad-wrap > div {
 
    overflow: hidden;
}

.cart__action__btn .cart__btn .btn {
        width: 70px !important;
        height: 41px !important;
		padding: 0px 0px !important;
}

@media screen and (min-width: 1200px)
{
.product-card__wrapper.items-1-5 .product-card {
    width: 243px;
    margin: 10px;
}}

.New_clear{
	background-repeat: round !important;
	background-size: cover !important;
}


.adadadadxxx{
	display: block !important;
	background-size: cover !important;
	background-repeat: no-repeat !important;
	background-color: #ffd030 !important;
}
</style>
